import { getCaminhao, getCaminhaoById, normalizeCaminhaoRegistro } from './caminhoesService';
import { getResultadoSequencialData, normalizeResultadoSequencial, buildCabecalho } from './resultadoSequencialService';
import { getSessionClientId } from './authSession';

// Busca os caminhões das concretagens selecionadas e cruza com os resultados de ruptura
// resolvidos (mesma fonte do relatório sequencial), agrupando por caminhão.
// Retorna { grupos, cabecalhoBase }: grupos = [{ caminhao, linhas, fck, ponderadorTipoCimento }],
// cabecalhoBase = dados de cliente/obra comuns a todas as páginas (mesma origem do sequencial).
export async function getCaminhoesComResultados({ idsConcretagem, idObra, idCliente } = {}) {
  if (!idsConcretagem || idsConcretagem.length === 0) return { grupos: [], cabecalhoBase: {} };

  const effectiveClientId = idCliente || getSessionClientId();

  const [caminhoesData, resultadoData] = await Promise.all([
    getCaminhao(effectiveClientId),
    getResultadoSequencialData({ idsConcretagem, idObra }),
  ]);

  const caminhoesList = Array.isArray(caminhoesData) ? caminhoesData : caminhoesData?.items || [];
  const idsConcretagemStr = idsConcretagem.map(String);
  const caminhoes = caminhoesList
    .map(normalizeCaminhaoRegistro)
    .filter((c) => c.id && idsConcretagemStr.includes(String(c.idConcretagem)));

  const resultadoList = Array.isArray(resultadoData) ? resultadoData : resultadoData?.items || [];
  const resultados = resultadoList.map(normalizeResultadoSequencial).filter((item) => item.id);

  // Busca o detalhe (corpoProvas) de cada caminhão em paralelo.
  const detalhes = await Promise.all(
    caminhoes.map((c) => getCaminhaoById(c.id, effectiveClientId).catch(() => null))
  );

  const grupos = caminhoes.map((caminhao, index) => {
    const detalhe = detalhes[index];
    const corposProva = detalhe?.corpoProvas || detalhe?.CorpoProvas || [];

    // AJUSTE BACKEND AQUI: /api/resultadoSequencial não expõe hoje o vínculo direto com o
    // caminhão de origem do corpo de prova. Cruza por etiqueta (idenObraEtiqueta), que é o
    // identificador visível ao usuário e único dentro de uma concretagem. Se o backend passar
    // a expor item.caminhao/idCaminhao no resultado, trocar este cruzamento para usar o id.
    const linhas = corposProva.map((cp) => {
      const etiqueta = cp.idenObraEtiqueta || cp.IdenObraEtiqueta || cp.etiqueta || '-';
      const resultado = resultados.find((r) => String(r.etiqueta) === String(etiqueta));
      return {
        id: String(cp.id || cp.idCorpoProva || `${caminhao.id}-${etiqueta}`),
        etiqueta,
        idadeRuptura: cp.idadeRuptura ?? cp.IdadeRuptura ?? resultado?.idadeRuptura ?? null,
        dataRuptura: cp.dataRuptura ?? cp.DataRuptura ?? resultado?.dataRuptura ?? null,
        fcj: resultado?.fcj ?? null,
        corFcj: resultado?.corFcj ?? null,
        tipoRuptura: resultado?.tipoRuptura ?? null,
        prensa: resultado?.prensa ?? null,
        temResultado: resultado?.fcj != null,
      };
    });

    const fck = resultados.find((r) => r.fck != null)?.fck ?? null;
    const ponderadorTipoCimento = resultados.find((r) => r.ponderadorTipoCimento != null)?.ponderadorTipoCimento ?? null;

    return { caminhao, linhas, fck, ponderadorTipoCimento };
  });

  return { grupos, cabecalhoBase: buildCabecalho(resultados) };
}

// Retorna o Set de ids de concretagem que têm ao menos um caminhão vinculado
// (usado para só listar, na tela, datas que realmente permitem gerar o relatório).
export async function getConcretagensComCaminhao({ idsConcretagem, idCliente } = {}) {
  if (!idsConcretagem || idsConcretagem.length === 0) return new Set();

  const effectiveClientId = idCliente || getSessionClientId();
  const caminhoesData = await getCaminhao(effectiveClientId);
  const caminhoesList = Array.isArray(caminhoesData) ? caminhoesData : caminhoesData?.items || [];
  const idsConcretagemStr = idsConcretagem.map(String);

  const idsComCaminhao = caminhoesList
    .map(normalizeCaminhaoRegistro)
    .filter((c) => c.idConcretagem && idsConcretagemStr.includes(String(c.idConcretagem)))
    .map((c) => String(c.idConcretagem));

  return new Set(idsComCaminhao);
}

